import React from 'react'
import { Col } from 'styled-bootstrap-grid'
import { useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { CenteredRow } from '../../../components/Page/Layout'
import { getThemeValidationResult, isValidating, selectedTheme } from '../../../features/theme/selectors'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNav, NavProps, WizardNavigationWrapper } from '../../../components/Wizard/WizardNav'
import ColorPicker from '../../../components/ColorPicker'
import { Row } from '../../../components/Grid'

const BalloonWrapperAngel = styled.div<{ background?: string; color?: string }>`
  .chat-body {
    margin-left: 20px;
    border-radius: 0px 8px 8px 8px;
    color: ${({ color }) => color || 'white'};
    float: left;
    background: ${({ background }) => background || 'blue'};
    padding: 5px 20px;
    p {
      margin: 0;
    }
    .footer_msg {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      text-align: right;
      margin-top: 5px;
    }
  }
`

const BalloonWrapperUser = styled.div<{ background?: string; color?: string }>`
  .chat-body {
    margin-right: 20px;
    border-radius: 8px 0px 8px 8px;
    float: right;
    color: ${({ color }) => color || 'white'};
    background: ${({ background }) => background || 'blue'};
    padding: 5px 20px;
    p {
      margin: 0;
    }
    .footer_msg {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      text-align: right;
      margin-top: 5px;
    }
  }
`

const MessageBox = styled.div<{ background?: string; btnColor?: string; btnBackground?: string }>`
  .chat-box {
    padding-top: 15px;
    padding-bottom: 10px;
    background: ${({ background }) => background || '#eee'};
  }

  .input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }

  input {
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s;
    position: relative;
    flex: 1 1 0%;
    min-width: 0;
    margin: 0px 8px;
    border-radius: 0.25rem !important;
  }

  button {
    margin-right: 6px;
    background-color: ${({ btnBackground }) => btnBackground || '#629d33'};
    border-color: ${({ btnBackground }) => btnBackground || '#629d33'};
    color: ${({ btnColor }) => btnColor || 'white'};
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }
  button:not(:disabled),
  [type='button']:not(:disabled),
  [type='reset']:not(:disabled),
  [type='submit']:not(:disabled) {
    cursor: pointer;
  }
`
const ChatColumn = styled(Col)<{ background?: string }>`
  background: ${({ background }) => background || '#fff'};
  padding: 0;
`

const MessageBoxRow = styled(Row)`
  position: absolute;
  bottom: 0;
  margin: 0;
  display: block;
  width: 100%;
  .message-col {
    padding: 0;
  }
`

type Props = {
  close?: () => void
} & NavProps

export const AddBalloonColors = ({ ...rest }: Props) => {
  const status = useSelector(getThemeValidationResult)
  const theme = useSelector(selectedTheme)
  const loading = useSelector(isValidating)

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Inserisci i Colori per la Chat</CenteredRow>

        <Row marginV={20}>
          <Col md={8} xs={12}>
            <Row marginV={30}>
              <Col md={6} xs={12}>
                <ColorPicker label="Sfondo balloon Angel" field="balloon_angel_bg_color" />
              </Col>
              <Col md={6} xs={12}>
                <ColorPicker label="Testo balloon Angel" field="balloon_angel_fg_color" />
              </Col>
            </Row>
            <Row marginV={30}>
              <Col md={6} xs={12}>
                <ColorPicker label="Sfondo balloon Utente" field="balloon_user_bg_color" />
              </Col>
              <Col md={6} xs={12}>
                <ColorPicker label="Testo balloon Utente" field="balloon_user_fg_color" />
              </Col>
            </Row>
            <Row marginV={30}>
              <Col md={6} xs={12}>
                <ColorPicker label="Sfondo Chat" field="chat_bg_color" />
              </Col>
              <Col md={6} xs={12}>
                <ColorPicker label="Sfondo Box Invio" field="chat_send_bg_color" />
              </Col>
            </Row>
            <Row marginV={30}>
              <Col md={6} xs={12}>
                <ColorPicker label="Sfondo Bottone Invio" field="chat_send_button_bg_color" />
              </Col>
              <Col md={6} xs={12}>
                <ColorPicker label="Testo Bottone Invio" field="chat_send_button_fg_color" />
              </Col>
            </Row>
          </Col>

          <ChatColumn md={4} xs={12} background={theme?.chat_bg_color}>
            <Row marginV={30}>
              <Col>
                <BalloonWrapperAngel
                  background={theme?.balloon_angel_bg_color || 'green'}
                  color={theme?.balloon_angel_fg_color || 'white'}
                >
                  <div className="chat-body clearfix">
                    <p>Ehi! Ciao!</p>
                    <div className="footer_msg d-flex justify-content-between pt-1">
                      <span />
                      <span>10/01 16:56</span>
                    </div>
                  </div>
                </BalloonWrapperAngel>
              </Col>
            </Row>
            <Row marginV={30}>
              <Col>
                <BalloonWrapperUser
                  background={theme?.balloon_user_bg_color || 'green'}
                  color={theme?.balloon_user_fg_color || 'white'}
                >
                  <div className="chat-body clearfix">
                    <p>Ciao!</p>
                    <div className="footer_msg d-flex justify-content-between pt-1">
                      <span>
                        10/01 16:57
                        <span className="delivery-status sent-now ">
                          <i className="ml-1 mdi mdi-check-all send" />
                        </span>
                      </span>
                    </div>
                  </div>
                </BalloonWrapperUser>
              </Col>
            </Row>

            <MessageBoxRow>
              <Col className="message-col">
                <MessageBox
                  btnColor={theme?.chat_send_button_fg_color}
                  background={theme?.chat_send_bg_color}
                  btnBackground={theme?.chat_send_button_bg_color}
                >
                  <div className="chat-box">
                    <div className="form-group">
                      <div className="input-group clearfix">
                        <input type="text" placeholder="Scrivi un messaggio..." className="message_input" />
                        <button type="submit" id="sendMsg" className="btn btn-success">
                          Invia
                        </button>
                      </div>
                    </div>
                  </div>
                </MessageBox>
              </Col>
            </MessageBoxRow>
          </ChatColumn>
        </Row>

        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid} />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
